import Bullet from 'components/prism/bullet';
import NoResults from 'components/prism/noResults';
import Subheader from 'components/prism/subheader';
import { ArrayHelpers, Paging, SystemText } from 'e4shared';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { isPast, isToday, isFuture } from 'helpers/dates';

const getReviewText = (item, isManagerOrCoach) => {
    if (item.reviewType === 'seller_only') {
        // Incomplete, overdue. Seller
        if (isPast(item.due)) {
            return {
                name: SystemText('Welcome/ToDo/Review/YourReviewOverdue'),
                description: SystemText('Welcome/ToDo/Review/YourReviewOverdue/Sub'),
            };
        }
        // Incomplete, due today. Seller
        else if (isToday(item.due)) {
            return {
                name: SystemText('Welcome/ToDo/Review/YourReviewDueToday'),
                description: SystemText('Welcome/ToDo/Review/YourReviewDueToday/Sub'),
            };
        }
        // Incomplete, upcoming. Seller
        else if (isFuture(item.due)) {
            return {
                name: SystemText('Welcome/ToDo/Review/YouveBeenAssigned'),
                description: SystemText('Welcome/ToDo/Review/YouveBeenAssigned/Sub'),
            };
        }
    } else if (item.reviewType === 'seller_and_manager_or_coach') {
        // Seller Complete, Manager/Coach incomplete
        if (item.sellerPartComplete && !item.managerOrCoachPartComplete) {
            if (isPast(item.due)) {
                // Seller complete, Manager/Coach incomplete, overdue. Manager/Coach
                if (isManagerOrCoach) {
                    return {
                        name: SystemText('Welcome/ToDo/Review/YourPortionOfTeamMembersOverdue'),
                        description: SystemText('Welcome/ToDo/Review/YourPortionOfTeamMembersOverdue/Sub'),
                    };
                }
                // Seller complete, Manager/Coach incomplete, overdue. Seller
                else {
                    return {
                        name: SystemText('Welcome/ToDo/Review/YouveCompletedYourPortion'),
                        description: SystemText('Welcome/ToDo/Review/YouveCompletedYourPortion/Sub'),
                    };
                }
            } else if (isToday(item.due)) {
                // Seller complete, Manager/Coach incomplete, due today. Manager/Coach
                if (isManagerOrCoach) {
                    return {
                        name: SystemText('Welcome/ToDo/Review/YourPortionCompletedOfTeamMembersDueToday'),
                        description: SystemText('Welcome/ToDo/Review/YourPortionCompletedOfTeamMembersDueToday/Sub'),
                    };
                }
                // Seller complete, Manager/Coach incomplete, due today. Seller
                else {
                    return {
                        name: SystemText('Welcome/ToDo/Review/YouveCompletedYourPortion'),
                        description: SystemText('Welcome/ToDo/Review/YouveCompletedYourPortion/Sub'),
                    };
                }
            } else if (isFuture(item.due)) {
                // Seller complete, Manager/Coach incomplete, upcoming. Manager/Coach
                if (isManagerOrCoach) {
                    return {
                        name: SystemText('Welcome/ToDo/Review/YouveBeenAssignedAReviewToComplete'),
                        description: SystemText('Welcome/ToDo/Review/YouveBeenAssignedAReviewToComplete/Sub'),
                    };
                }
                // Seller complete, Manager/Coach incomplete, upcoming. Seller
                else {
                    return {
                        name: SystemText('Welcome/ToDo/Review/YouveCompletedYourPortion'),
                        description: SystemText('Welcome/ToDo/Review/YouveCompletedYourPortion/Sub'),
                    };
                }
            }
        }
        // Seller incomplete, Manager/Coach complete
        else if (!item.sellerPartComplete && item.managerOrCoachPartComplete) {
            if (isPast(item.due)) {
                // Seller incomplete, Manager/Coach complete, overdue. Manager/Coach
                if (isManagerOrCoach) {
                    return {
                        name: SystemText('Welcome/ToDo/Review/YouveCompletedYourPortionOfTeamMembers'),
                        description: SystemText('Welcome/ToDo/Review/YouveCompletedYourPortionOfTeamMembers/Sub'),
                    };
                }
                // Seller incomplete, Manager/Coach complete, overdue. Seller
                else {
                    return {
                        name: SystemText('Welcome/ToDo/Review/YourPortionOverdue'),
                        description: SystemText('Welcome/ToDo/Review/YourPortionOverdue/Sub'),
                    };
                }
            } else if (isToday(item.due)) {
                // Seller incomplete, Manager/Coach complete, due today. Manager/Coach
                if (isManagerOrCoach) {
                    return {
                        name: SystemText('Welcome/ToDo/Review/YouveCompletedYourPortionOfTeamMembers'),
                        description: SystemText('Welcome/ToDo/Review/YouveCompletedYourPortionOfTeamMembers/Sub'),
                    };
                }
                // Seller incomplete, Manager/Coach complete, due today. Seller
                else {
                    return {
                        name: SystemText('Welcome/ToDo/Review/YourPortionDueToday'),
                        description: SystemText('Welcome/ToDo/Review/YourPortionDueToday/Sub'),
                    };
                }
            } else if (isFuture(item.due)) {
                // Seller incomplete, Manager/Coach complete, upcoming. Manager/Coach
                if (isManagerOrCoach) {
                    return {
                        name: SystemText('Welcome/ToDo/Review/YouveCompletedYourPortionOfTeamMembers'),
                        description: SystemText('Welcome/ToDo/Review/YouveCompletedYourPortionOfTeamMembers/Sub'),
                    };
                }
                // Seller incomplete, Manager/Coach complete, upcoming. Seller
                else {
                    return {
                        name: SystemText('Welcome/ToDo/Review/YouAndYourManagerCoachAssignedReview'),
                        description: SystemText('Welcome/ToDo/Review/YouAndYourManagerCoachAssignedReview/Sub'),
                    };
                }
            }
        }
        // Both incomplete
        if (!item.sellerPartComplete && !item.managerOrCoachPartComplete) {
            if (isPast(item.due)) {
                if (isManagerOrCoach) {
                    return {
                        name: SystemText('Welcome/ToDo/Review/YourTeamMemberOverdue'),
                        description: SystemText('Welcome/ToDo/Review/YourTeamMemberOverdue/Sub'),
                    };
                } else {
                    return {
                        name: SystemText('Welcome/ToDo/Review/YourReviewOverdue'),
                        description: SystemText('Welcome/ToDo/Review/YourReviewOverdue/Sub'),
                    };
                }
            } else if (isToday(item.due)) {
                if (isManagerOrCoach) {
                    return {
                        name: SystemText('Welcome/ToDo/Review/YourTeamMemberDueToday'),
                        description: SystemText('Welcome/ToDo/Review/YourTeamMemberDueToday/Sub'),
                    };
                } else {
                    return {
                        name: SystemText('Welcome/ToDo/Review/YourReviewDueToday'),
                        description: SystemText('Welcome/ToDo/Review/YourReviewDueToday/Sub'),
                    };
                }
            } else if (isFuture(item.due)) {
                if (isManagerOrCoach) {
                    return {
                        name: SystemText('Welcome/ToDo/Review/YouveBeenAssignedAReviewToComplete'),
                        description: SystemText('Welcome/ToDo/Review/YouveBeenAssignedAReviewToComplete/Sub'),
                    };
                } else {
                    return {
                        name: SystemText('Welcome/ToDo/Review/YouveBeenAssigned'),
                        description: SystemText('Welcome/ToDo/Review/YouveBeenAssigned/Sub'),
                    };
                }
            }
        }
    } else if (item.reviewType === 'manager_only') {
        // Incomplete, overdue. Manager/Coach
        if (isPast(item.due)) {
            return {
                name: SystemText('Welcome/ToDo/Review/YourTeamMemberOverdue'),
                description: SystemText('Welcome/ToDo/Review/YourTeamMemberOverdue/Sub'),
            };
        }
        // Incomplete, due today. Manager/Coach
        else if (isToday(item.due)) {
            return {
                name: SystemText('Welcome/ToDo/Review/YourTeamMemberDueToday'),
                description: SystemText('Welcome/ToDo/Review/YourTeamMemberDueToday/Sub'),
            };
        }
        // Incomplete, upcoming. Manager/Coach
        else if (isFuture(item.due)) {
            return {
                name: SystemText('Welcome/ToDo/Review/YouveBeenAssignedAReviewToComplete'),
                description: SystemText('Welcome/ToDo/Review/YouveBeenAssignedAReviewToComplete/Sub'),
            };
        }
    }

    // Default fallback
    return {
        name: SystemText('Welcome/ToDo/ReviewTitle'),
        description: SystemText('Welcome/ToDo/ReviewSummary'),
    };
};

export const ToDo = ({ text, data, profileId, hasPathway, hasBehaviours }) => {
    const pageSize = 3;
    const [page, setPage] = React.useState(1);

    const user = useSelector(state => state.user.user);
    const downline = useSelector(state => state.user.downline);
    const coaching = useSelector(state => state.user.coaching);

    // Helper function to determine if current user is manager/coach for a specific review item
    const isManagerOrCoachForItem = item => {
        if (user?.administrator) return true;

        // Check if user is the direct manager of the person being reviewed
        if (item.manager_Id && user.id === item.manager_Id) return true;

        // Check if the person being reviewed is in the user's downline (upline manager)
        if (downline?.some(d => d.id === item.profile_Id && d.id !== user.id)) return true;

        // Check if the person being reviewed is in the user's coaching list
        if (coaching?.some(c => c.id === item.profile_Id)) return true;

        return false;
    };

    return (
        <>
            <Subheader title={text.title} count={data?.length} />
            {ArrayHelpers.getPage(data, page, pageSize).map(item => {
                let link = '';
                let type = '';
                let subType = '';

                switch (item.type) {
                    case 'review':
                        type = 'review';

                        const isManagerOrCoach = isManagerOrCoachForItem(item);

                        if (isManagerOrCoach) {
                            link = `/team-member/${item.profile_Id}?tab=reviews`;
                        } else {
                            link = `/develop/reviews/${profileId}`;
                        }

                        // Get the review text based on review type and status
                        const reviewText = getReviewText(item, isManagerOrCoach);
                        item.name = reviewText.name;
                        item.description = reviewText.description;

                        break;
                    default: // must be an objective
                        type = 'objective';
                        subType = item.type;
                        link = `/objectives/${profileId}/objective/${item.id}`;
                        break;
                }

                return (
                    <Link
                        data-testid="todo-item"
                        key={`todo-${item.type}-${item.id}`}
                        to={link}
                        className="prism-content-box mt10"
                    >
                        <div className="prism-content">
                            <div className="flex flex-center">
                                <Bullet type={type} subType={subType} />
                                <h4 className="ml10">{item.name}</h4>
                            </div>
                            {item.description && <p className="truncate-4">{item.description}</p>}
                            <div>
                                <Bullet isOpenDueDate value={item.due} />
                                {item.duration > 0 && (
                                    <span className="ml10">
                                        <Bullet isDuration value={item.duration / 60} />
                                    </span>
                                )}
                            </div>
                        </div>
                    </Link>
                );
            })}
            {data.length > pageSize && (
                <div className="mt10 text-center welcome-paging">
                    <Paging recordCount={data.length} page={page} pageSize={pageSize} goToPage={setPage} />
                </div>
            )}
            {data.length === 0 && (
                <NoResults
                    icon="check-square"
                    title={hasPathway ? text.noResultsPathway : text.noResults}
                    summary={
                        hasPathway
                            ? text.noResultsSummaryPathway
                            : hasBehaviours
                              ? text.noResultsSummaryBehaviours
                              : text.noResultsSummary
                    }
                />
            )}
        </>
    );
};

export default ToDo;
